import React, { useState } from "react";
import "./index.css";

/**
 * CopyLinkButton: Displays on block hover, copies page URL with anchor hash to clipboard.
 * Used for campaign URL building — displays a link icon that copies URL#anchorId.
 */
const CopyLinkButton = ({ anchorId, pageUrl = "", className = "" }) => {
  const [copied, setCopied] = useState(false);

  if (!anchorId) return null;

  const handleCopy = () => {
    if (typeof window === "undefined") return;

    // Build the full URL with anchor hash
    const baseUrl = pageUrl || window.location.href.split("#")[0];
    const fullUrl = `${baseUrl}#${anchorId}`;

    navigator.clipboard
      .writeText(fullUrl)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch(err => {
        console.warn("Failed to copy URL:", err);
      });
  };

  return (
    <button
      className={`copy-link-button ${copied ? "is-copied" : ""} ${className}`.trim()}
      onClick={handleCopy}
      title={copied ? "Copied!" : "Copy link to this section"}
      aria-label="Copy link to this section"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
        <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
      </svg>
      {copied && <span className="copy-feedback">Copied!</span>}
    </button>
  );
};

export default CopyLinkButton;